import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Route } from '@angular/router';
import { CampuscctvserviceService } from '../service/campuscctvservice.service';



@Component({
  selector: 'app-buildings',
  templateUrl: './buildings.component.html',
  styleUrls: ['./buildings.component.scss']
})
export class BuildingsComponent implements OnInit {
  building: any[] = [];
  constructor(public campuscctvserviceservice:CampuscctvserviceService,public router: ActivatedRoute) { }
  ngOnInit(): void {
    const id = this.router.snapshot.params['id']
    this.campuscctvserviceservice.getBuildingData(id).subscribe(
      {
        next: (httpResponse: any) => {
          this.building = httpResponse
          console.log('data', this.building);
        },
        error: (err) => {
          console.log('error', err);
        },
        complete: () => {
          console.log('completed!');
        }
      }
    )
  
  }

}
